import { type ValueOf } from '@dni-types/utilities/value-of'
import { Box } from '@pets-ui/Box/Box'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useTranslation } from 'react-i18next'
import cartUiI18nInstance from '../i18n/i18nConfig'

const COUPON_STATUS = {
  IS_OUT_OF_STOCK: 'isOutOfStock',
  IS_REACH_USER_LIMIT: 'isReachUserLimit',
  IS_RUN_OUT: 'isRunOut',
} as const

const CHIP_OF_COUPON_STATUS: Partial<Record<ValueOf<typeof COUPON_STATUS>, {
  text: [string, { defaultValue: string }]
  color: string
  borderColor: string
  backgroundColor: string
}>> = {
  [COUPON_STATUS.IS_OUT_OF_STOCK]: {
    text: ['cartUi.allGivenAway', { defaultValue: '已贈完' }],
    color: colors.grey600,
    borderColor: colors.grey600,
    backgroundColor: colors.grey100,
  },
  [COUPON_STATUS.IS_REACH_USER_LIMIT]: {
    text: ['cartUi.used', { defaultValue: '已用過' }],
    color: colors.grey600,
    borderColor: colors.grey600,
    backgroundColor: colors.grey100,
  },
  [COUPON_STATUS.IS_RUN_OUT]: {
    text: ['cartUi.allClaimed', { defaultValue: '已搶完' }],
    color: colors.grey600,
    borderColor: colors.grey600,
    backgroundColor: colors.grey100,
  },
}

export interface CouponListItemStatusProps {
  isReachUserLimit?: boolean
  isRunOut?: boolean
  isOutOfStock?: boolean
}

export const CouponListItemStatus = (props: CouponListItemStatusProps) => {
  const { isReachUserLimit, isRunOut, isOutOfStock } = props
  const { t } = useTranslation('cartUi', { i18n: cartUiI18nInstance })
  const couponStatus = [
    { condition: isReachUserLimit, status: COUPON_STATUS.IS_REACH_USER_LIMIT },
    { condition: isRunOut, status: COUPON_STATUS.IS_RUN_OUT },
    { condition: isOutOfStock, status: COUPON_STATUS.IS_OUT_OF_STOCK },
  ].find(({ condition }) => condition)?.status
  if (!couponStatus) return null
  const chipTextConfig = CHIP_OF_COUPON_STATUS[couponStatus]
  const text = chipTextConfig?.text ? t(...(chipTextConfig.text)) : ''
  return (
    <Box position="absolute" top={0} left={0} right={0} bottom={0} zIndex={1}>
      <Box position="absolute" top={0} left={0} right={0} bottom={0} backgroundColor="#ffffff" opacity={0.6} />
      <Box
        color={chipTextConfig?.color}
        borderColor={chipTextConfig?.borderColor}
        backgroundColor={chipTextConfig?.backgroundColor}
        borderWidth={1}
        borderStyle="solid"
        px={1}
        py={0.5}
        borderRadius={4}
        fontSize={10}
        whiteSpace="nowrap"
        position="absolute"
        right={6}
        bottom={6}
      >
        {text}
      </Box>
    </Box>
  )
}
